export const topics = [
  {
    id: "music-festival-video",
    title: "音乐节现场视频被二次剪辑传播事件",
    category: "娱乐动态",
    status: "追证中",
    credibility: 71,
    heat: 92,
    date: "2026-08-28",
    updated: "2026-09-06",
    evidenceCount: 6,
    featured: true,
    summary:
      "一段音乐节现场短视频在多个账号间被反复转发，画面顺序与前后的音频出现错位。我们比对了三位现场观众拍摄的原始素材，梳理出剪辑发生在哪一步。",
    tags: ["视频剪辑", "现场还原", "时间线"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20a%20concert%20stage%20silhouette%20with%20scattered%20video%20frames%20and%20timeline%20markers%20on%20warm%20cream%20paper%20background%2C%20muted%20vermillion%20and%20amber%20accents%2C%20grain%20texture%2C%20investigative%20documentary%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-01&orientation=landscape",
  },
  {
    id: "brand-live-price",
    title: "品牌直播「临时改价」截图对比",
    category: "商业代言",
    status: "已核实",
    credibility: 88,
    heat: 84,
    date: "2026-08-20",
    updated: "2026-09-04",
    evidenceCount: 8,
    featured: true,
    summary:
      "有观众反映某场直播中商品价格在开播后被上调。我们抓取了同一商品的页面快照与直播回放时间轴，确认改价确实发生在开播后第七分钟。",
    tags: ["价格截图", "直播回放", "快照比对"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20shopping%20price%20tags%20and%20screenshot%20frames%20arranged%20like%20evidence%20on%20warm%20beige%20paper%2C%20muted%20vermillion%20and%20olive%20accents%2C%20soft%20grain%2C%20investigative%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-02&orientation=landscape",
  },
  {
    id: "chat-record-leak",
    title: "社交平台聊天记录截图真伪讨论",
    category: "社交网络",
    status: "存疑",
    credibility: 43,
    heat: 96,
    date: "2026-09-02",
    updated: "2026-09-08",
    evidenceCount: 4,
    featured: true,
    summary:
      "一组标注为「内部聊天记录」的截图在小范围流传。截图存在两处字体基线与消息排序异常，目前无法确认其来源，暂列为存疑。",
    tags: ["聊天截图", "字体比对", "来源不明"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20overlapping%20chat%20bubble%20shapes%20and%20screen%20captures%20pinned%20on%20warm%20paper%20board%2C%20muted%20amber%20and%20sage%20accents%2C%20subtle%20grain%20texture%2C%20investigative%20collage%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-03&orientation=landscape",
  },
  {
    id: "charity-donation",
    title: "公益捐赠金额传闻核查",
    category: "网络传闻",
    status: "已核实",
    credibility: 92,
    heat: 78,
    date: "2026-08-11",
    updated: "2026-08-30",
    evidenceCount: 7,
    featured: false,
    summary:
      "网传某次公益活动的捐赠金额与实际公示存在差额。我们对照公开的捐赠公示页面与活动方说明，差额来自统计口径不同，并非遗漏。",
    tags: ["公益公示", "口径差异", "数据核对"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20donation%20receipt%20stamps%20and%20ledger%20lines%20on%20warm%20ivory%20paper%2C%20muted%20vermillion%20and%20olive%20accents%2C%20soft%20grain%20texture%2C%20calm%20documentary%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-04&orientation=landscape",
  },
  {
    id: "award-backstage-audio",
    title: "颁奖礼后台录音流出事件",
    category: "娱乐动态",
    status: "追证中",
    credibility: 66,
    heat: 89,
    date: "2026-08-25",
    updated: "2026-09-05",
    evidenceCount: 5,
    featured: false,
    summary:
      "一段疑似后台对话的录音被放出，音频存在明显的降噪与环境音缺失。我们对比了同场活动的公开直播音轨，给出目前的判断依据。",
    tags: ["录音分析", "音轨对比", "环境音"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20an%20audio%20waveform%20and%20backstage%20curtain%20abstract%20shapes%20on%20warm%20cream%20paper%2C%20muted%20amber%20and%20vermillion%20accents%2C%20grain%20texture%2C%20investigative%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-05&orientation=landscape",
  },
  {
    id: "product-safety-claims",
    title: "网红产品安全性质疑汇总",
    category: "行业风向",
    status: "追证中",
    credibility: 74,
    heat: 81,
    date: "2026-08-17",
    updated: "2026-09-01",
    evidenceCount: 9,
    featured: false,
    summary:
      "围绕一款热销产品的安全性出现多版本说法。我们整理了公开检测报告、配料表截图与商家回应，把能被验证与暂不能验证的部分分开列出。",
    tags: ["检测报告", "配料表", "多方回应"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20laboratory%20test%20tubes%20and%20checklist%20documents%20on%20warm%20beige%20paper%20background%2C%20muted%20sage%20and%20amber%20accents%2C%20soft%20grain%2C%20investigative%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-06&orientation=landscape",
  },
  {
    id: "old-photo-misread",
    title: "旧照被误传为近照的时间线还原",
    category: "网络传闻",
    status: "已澄清",
    credibility: 95,
    heat: 69,
    date: "2026-08-05",
    updated: "2026-08-22",
    evidenceCount: 6,
    featured: false,
    summary:
      "一张被当作近期照片传播的图片，实际拍摄于数年前。我们通过同款服装的上市时间、背景店铺招牌与原始发布记录完成时间线还原。",
    tags: ["旧照复原", "拍摄时间", "首发记录"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20stacked%20photo%20prints%20and%20a%20clock%20timeline%20on%20warm%20ivory%20paper%2C%20faded%20sepia%20tones%20with%20amber%20accents%2C%20subtle%20grain%2C%20archival%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-07&orientation=landscape",
  },
  {
    id: "revenue-share-chat",
    title: "合作分成争议的对话截图",
    category: "商业代言",
    status: "存疑",
    credibility: 51,
    heat: 73,
    date: "2026-08-13",
    updated: "2026-08-29",
    evidenceCount: 5,
    featured: false,
    summary:
      "双方就分成比例各执一词，各自公开了部分对话截图。由于截图均经过裁剪且缺少上下文，我们只标注可交叉验证的片段，不做定论。",
    tags: ["分成争议", "截图裁剪", "交叉验证"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20coins%20contract%20lines%20and%20chat%20fragments%20on%20warm%20cream%20paper%2C%20muted%20vermillion%20and%20sage%20accents%2C%20soft%20grain%2C%20investigative%20collage%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-08&orientation=landscape",
  },
  {
    id: "ai-voice-clip",
    title: "疑似AI合成语音的辨认过程",
    category: "行业风向",
    status: "已核实",
    credibility: 85,
    heat: 87,
    date: "2026-08-30",
    updated: "2026-09-07",
    evidenceCount: 7,
    featured: false,
    summary:
      "一段被指为本人发言的语音广泛传播。通过呼吸停顿、齿音细节与频谱比对，我们记录了判定为合成语音的几个关键依据。",
    tags: ["语音合成", "频谱比对", "呼吸停顿"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20sound%20waves%20morphing%20into%20digital%20grid%20lines%20on%20warm%20paper%20background%2C%20muted%20amber%20and%20olive%20accents%2C%20subtle%20grain%2C%20technology%20investigative%20mood%2C%20high%20detail&width=800&height=500&seq=topic-cover-09&orientation=landscape",
  },
];

export const topicCategories = [
  "全部",
  "娱乐动态",
  "社交网络",
  "商业代言",
  "网络传闻",
  "行业风向",
];